import Enums from "../../../enums/enums";
const state = {
  userFeedbackVideo: [],
  userFeedbackVideoLoadingStatus: Enums.LoadingStatusType.None,
};

const getters = {
  GetUserFeedbackVideo: (state) => {
    return state.userFeedbackVideo;
  },
  GetUserFeedbackVideoLoadingStatus: (state) => {
    return state.userFeedbackVideoLoadingStatus;
  },
};
export { getters, state };

